import React, { useState } from "react"
import { homeSlidesOne } from "../data/data"
import { BsFillCircleFill } from "react-icons/bs"
import check from "../images/mobile-check.svg"

export default function HomeSlidesOne() {
  const [cards] = useState(homeSlidesOne)
  const [value, setValue] = useState(0)

  const { image, title, desc } = cards[value]

  return (
    <>
      <section className="home__slides__one">
        <div className="px-5 2xl:px-0 py-10 lg:py-20 xl:max-w-6xl xl:mx-auto lg:relative">
          <article className="bg-blue p-5 rounded-2xl lg:p-0">
            <h4 className="text-white uppercase text-xl lg:hidden">{title}</h4>

            <div className="flex">
              {cards.map((card, index) => (
                <React.Fragment key={index}>
                  <h4
                    onClick={() => setValue(index)}
                    className={`heading bg-white p-5 uppercase text-2xl hidden lg:block mr-5 cursor-pointer rounded-lg transition-all duration-500 ${
                      index === value && "heading-active"
                    }`}
                  >
                    {card.title}
                    {index === value && <div className="underline"></div>}
                  </h4>
                </React.Fragment>
              ))}
            </div>

            <div className="underline lg:hidden"></div>
            <p className="text-white flex items-start lg:text-gray-800 lg:bg-white lg:pb-5 lg:pt-10 rounded mt-5 lg:mt-24">
              <img
                src={check}
                alt="checkmark"
                className="mr-3 mt-2 lg:hidden"
              />
              <img
                src={image}
                alt="checkmark"
                className="mr-5 hidden lg:block"
              />{" "}
              {desc}
            </p>

            <ul className="flex items-center justify-center mt-5 lg:hidden">
              {cards.map((card, index) => (
                <li key={index} className="mx-3">
                  <BsFillCircleFill
                    onClick={() => setValue(index)}
                    className={`text-xl gray-circle opacity-75 cursor-pointer ${
                      index === value && "white-circle opacity-100"
                    }`}
                  />
                </li>
              ))}
            </ul>
          </article>
        </div>
      </section>
    </>
  )
}
